// Angular
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
// Model
import {AUTHACTIONS, AUTHMESSAGE} from '../model/role.model';
// Service
import { OidcSecurityService} from 'angular-auth-oidc-client';
import {RoleService} from '../service/role.services';
import { AppInformationService } from '../service/app-info.service';
// Store
import {Store} from '@ngxs/store';
import {SetCurrentUrl} from '../action/state.action';
import { SetLoginMessage, UserContextState } from '@cv-invision/core';
// Other
import {map, Observable, of} from 'rxjs';
import jwt_decode from 'jwt-decode';

@Injectable({providedIn: 'root'})
export class RoleGuard implements CanActivate {
	constructor(
		private oidcSecurityService: OidcSecurityService,
		private roleService: RoleService,
		private appInfo: AppInformationService,
		private store: Store
	) {
	}

	/**
	 * Can activate validation.
	 * @param route: ActivatedRouteSnapshot
	 * @param state: RouterStateSnapshot
	 */
	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return this.validateUserAuth(state);
	}

	/**
	 * validate userAuth with third party lib
	 */
	validateUserAuth(state: RouterStateSnapshot): Observable<boolean> {
		const isPublicUser = this.store.selectSnapshot(UserContextState.isPublicUser);

		if (isPublicUser) {
			return this.validateUserViaPublicToken(state);
		} else {
			return this.validateUser(state);
		}
	}

	/**
	 * validate userAuth with third party lib
	 *
	 * @param state
	 * @returns
	 */
	validateUser(state: RouterStateSnapshot): Observable<any> {
		const isAuth = this.oidcSecurityService.isAuthenticated();

		if (isAuth) {
			console.groupCollapsed('ROLE.GUARD');
			console.log('isAuthenticated');
			console.log(isAuth);
			console.groupEnd();
			return of(this.roleService.checkUserRole(state));

		} else if (state.url !== '/') {
			const currentUrl = this.appInfo.currentUrl;
			if (state.url !== currentUrl) {
				this.store.dispatch(new SetCurrentUrl(state.url, this.appInfo.appName));
			}

			console.groupCollapsed('ROLE.GUARD');
			console.log('unauthorized & have url different than default');
			console.log(isAuth);
			console.log(this.oidcSecurityService.isAuthenticated());
			console.log(this.oidcSecurityService.getAccessToken());
			console.log(this.oidcSecurityService.getUserData());
			console.groupEnd();

			this.oidcSecurityService.authorize();
			return of(false);
		} else {
			console.groupCollapsed('ROLE.GUARD');
			console.log('completly unauthorized');
			console.log(this.oidcSecurityService.getAccessToken());
			console.log(this.oidcSecurityService.getUserData());
			console.groupEnd();

			this.roleService.unAuthSetValues(AUTHACTIONS.LOGIN);
			return of(false);
		}

		// For old reference, will clean up
		// return this.oidcSecurityService.isAuthenticated$
		// 	.pipe(
		// 		map(({ isAuthenticated }) => {
		// 			// allow navigation if authenticated
		// 			if (isAuthenticated) {
		// 				console.groupCollapsed('ROLE.GUARD');
		// 				console.log('isAuthenticated');
		// 				console.log(isAuthenticated);
		// 				return this.roleService.checkUserRole(state);

		// 			} else if (state.url !== '/') {
		// 				const currentUrl = this.appInfo.currentUrl;
		// 				if (state.url !== currentUrl) {
		// 					this.store.dispatch(new SetCurrentUrl(state.url, this.appInfo.appName));
		// 				}

		// 				console.groupCollapsed('ROLE.GUARD');
		// 				console.log('unauthorized & have url different than default');
		// 				console.log(isAuthenticated);
		// 				console.log(this.oidcSecurityService.isAuthenticated());
		// 				console.log(this.oidcSecurityService.getAccessToken());
		// 				console.log(this.oidcSecurityService.getUserData());
		// 				console.groupEnd();

		// 				this.oidcSecurityService.authorize();
		// 				return false;
		// 			} else {
		// 				console.groupCollapsed('ROLE.GUARD');
		// 				console.log('completly unauthorized');
		// 				console.log(this.oidcSecurityService.getAccessToken());
		// 				console.log(this.oidcSecurityService.getUserData());
		// 				console.groupEnd();

		// 				this.roleService.unAuthSetValues(AUTHACTIONS.LOGIN);
		// 				return false;
		// 			}
		// 		})
		// 	);
	}

	/**
	 * Validate user via Public token expiration
	 * @returns
	 */
	validateUserViaPublicToken(state: RouterStateSnapshot): Observable<any> {
		const token = this.store.selectSnapshot(UserContextState.token);
		let response = false;

		if (token) {
			const tokenData: any = jwt_decode(token as string);
			const now = Math.floor(Date.now() / 1000);

			if (now < tokenData.exp) {
				const checkRole = this.roleService.checkUserRole(state, true);
				if (checkRole) {
					response = true;
				} else {
					this.store.dispatch(new SetLoginMessage(AUTHMESSAGE.PERMISSION_ROLES_REQUIRED));
				}
			} else {
				this.store.dispatch(new SetLoginMessage(AUTHMESSAGE.TOKEN_EXPIRED));
			}
		}

		return of(response);
	}

}
